export default function PageHeader({ eyebrow, title, description, actions, children, testId }) {
    return (
        <div className="flex flex-col gap-4 pb-6 sm:flex-row sm:items-end sm:justify-between" data-testid={testId}>
            <div className="min-w-0 flex-1">
                {eyebrow && <div className="co-label mb-2">{eyebrow}</div>}
                <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium leading-tight text-[#0F1115] break-words">{title}</h1>
                {description && <p className="mt-2 max-w-2xl text-sm text-[#5E636E] leading-relaxed">{description}</p>}
                {children}
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2 max-w-full sm:max-w-[46%]">{actions}</div>}
        </div>
    );
}
